import { jwtDecode } from 'jwt-decode';

import { TokensResponseModel } from '@/api/api-client';
import { AuthUser, RefreshTokenResponseViewModel, TokenResponseViewModel } from '@/api/api-view-models/auth-models';

const mapUserInfo = (decoded: any): AuthUser => {
  return {
    name: decoded.name,
    nickname: decoded.nickname,
    pictureUrl: decoded.picture,
    email: decoded.email,
    updatedAt: decoded.updated_at,
    emailVerified: decoded.email_verified,
    roles: [],
  };
};

export const mapExchangeToken = (data: TokensResponseModel): TokenResponseViewModel => {
  const decoded = jwtDecode(data.id_token);

  return {
    accessToken: data.access_token,
    idToken: data.id_token,
    expiresIn: data.expires_in,
    tokenType: data.token_type,
    userInfo: mapUserInfo(decoded),
    refreshToken: data.refresh_token || '',
  };
};

export const mapRefreshToken = (data: TokensResponseModel): RefreshTokenResponseViewModel => {
  return {
    accessToken: data.access_token,
    expiresIn: data.expires_in,
    refreshToken: data.refresh_token || '',
  };
};